export interface Citizenship {
  id: number;
  name: string;
  image: string;
}
